// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_parking_parkinglines_completeness: MapboxStyleLayer[] = [
  {
    id: 'capacity_status-segment_too_small',
    type: 'line',
    paint: {
      'line-color': 'rgb(99, 53, 50)',
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
      'line-dasharray': [0.5, 0.5],
      'line-opacity': [
        'match',
        ['get', 'highway'],
        ['secondary', 'construction', 'pedestrian'],
        0.25,
        1,
      ],
    },
    filter: ['match', ['get', 'capacity_status'], ['segment_too_small'], true, false],
  },
  {
    id: 'capacity_status-no_parking',
    type: 'line',
    paint: {
      'line-color': 'hsl(273, 78%, 37%)',
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
    },
    filter: ['match', ['get', 'capacity_status'], ['no_parking'], true, false],
  },
  {
    id: 'capacity_status-data_missing',
    type: 'line',
    paint: {
      'line-color': 'rgb(187, 17, 133)',
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 10],
      'line-opacity': [
        'match',
        ['get', 'highway'],
        ['secondary', 'construction', 'pedestrian'],
        0.25,
        1,
      ],
    },
    filter: ['match', ['get', 'capacity_status'], ['data_missing'], true, false],
  },
]
